import { render } from "./TheHeader.vue?vue&type=template&id=5a2a645b&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./style.less?vue&type=style&index=0&id=5a2a645b&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2a645b"]])

export default __exports__